module.exports = "https://web-assets.ifttt.com/packs/media/review/feedback-icon-c58bbe87.svg";